import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../services/ApiService";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import PasswordComponent from "../components/verification/PasswordComponent";
import IconContentCard from "../components/shared/IconContentCard";
import { MdMarkEmailRead } from "react-icons/md";
import { FaServer, FaUnlink } from "react-icons/fa";

/**
 * MailVerifyPage 
 * 
 * after basic registration(HomePage modal fill) will be send email
 * with token, to verify customers email address
 * 
 * @url "/qr/mail/confimation/:token"
 * 
 * @components "components/verification/"
 * 
 * @returns {object} - saves known data to LocalStorage as json object
 */
const MailVerifyPage = () => {
    
    const API = new Api(); // Api Service
    const navigate = useNavigate(); // navigation
    const {token} = useParams(); // Client token which he got through mail
    const [tokenValid, setTokenValid] = useState(false) // Check for token if valid
    const [customer, setCustomer] = useState(); // Customer object
    const [loading, setLoading] = useState(true); // when data is loading
    const [apiError, setApiError] = useState("");
    const [isMailVerify] = useState(isNaN(token));


    // On render verifies email address, if exists show new password fields
    useEffect(() => {
        if (isMailVerify) {
            API.mail_verify(token)
                .then((res) => {
                    setLoading(false);
                    let data = res.data;
                    setCustomer(data);
                    setTokenValid(true);
                })
                .catch((err) => {
                    setLoading(false);
                    setTokenValid(false);
                    if (err.code === "ERR_NETWORK") {
                        return setApiError("Kein Verbindung zum Server.")
                    }
                    if (err.response.status === 404) {
                        return setApiError("Die aufgerufene Adresse existiert nicht oder ist bereits ungültig.")
                    }
                    if (err.response.data.detail !== undefined) {
                        return setApiError(err.response.data.detail);
                    } 
                    setApiError("Unbekannter Fehler.");
                });
        } else {
            API.mail_registration_verify_token(token)
                .then(res => {
                    res.data = Object.fromEntries(Object.entries(res.data).map(([key, value]) => [key, value === "False"? "": value]));
                    res.data.mailRegister = true;
                    res.data.qr_code = null;
                    res.data.phone = res.data.mobile;
                    
                    if (res.data.country_id.length === 0) {
                        res.data.country_id = "12";
                    } else {
                        res.data.country_id = res.data.country_id[0].toString();
                    }
                    if (res.data.state_id.length === 0) {
                        res.data.state_id = "";
                    } else {
                        res.data.state_id = res.data.state_id[0].toString();
                        console.log("this is state id", res.data.state_id)
                    }
                    if (res.data.company_type === "person") {
                        let splitenName = res.data.name.split(" ");
                        res.data.name = splitenName.shift();
                        res.data.last_name = splitenName.join(" ");
                    } else {
                        res.data.name = res.data.name;
                    }
                    if (res.data.street !== undefined && res.data.street !== "") {
                        var checkedStreet = splitAtFirstNumber(res.data.street);
                        if (typeof(checkedStreet) !== "string") {
                            res.data.street = checkedStreet[0];
                            if (checkedStreet[1].includes("/")) {
                                var splitedNr = checkedStreet[1].split("/");
                                if (splitedNr.length === 2) {
                                    res.data.houseNr = splitedNr[0];
                                    res.data.top = splitedNr[1]
                                }
                                if (splitedNr.length === 3) {
                                    res.data.houseNr = splitedNr[0];
                                    res.data.stiege = splitedNr[1];
                                    res.data.top = splitedNr[2];
                                }
                            } else {
                                res.data.houseNr = checkedStreet[1];
                            }
                        }
                    }
                    setLoading(false);
                    setCustomer(res.data);
                    setTokenValid(true);
                })
                .catch(err => {
                    setLoading(false);
                    setTokenValid(false);
                    if (err.code === "ERR_NETWORK") {
                        return setApiError("Kein Verbindung zum Server.")
                    }
                    if (err.response.status === 404) {
                        return setApiError("Die aufgerufene Adresse existiert nicht oder ist bereits ungültig.")
                    }
                    if (err.response.data.detail !== undefined) {
                        return setApiError(err.response.data.detail);
                    } 
                    setApiError("Unbekannter Fehler.");
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    

    const splitAtFirstNumber = (str) => {
        let match = str.match(/\d/);
        if (!match) return str;

        let index = match.index;
        return [str.slice(0, index), str.slice(index)];
    }

    // Views
    return (
        <Container>
            <Row className="mt-5 mb-5">
                <h3><span className="text-energo">ENERGO</span> - Willkommen im Managementportal</h3>
            </Row>

            {loading?
                <IconContentCard icon={<FaServer size={80} />}>
                    <Row>
                        <h5 className="text-energo">Daten werden überprüft...</h5>
                    </Row>
                    <Row>
                        <Col xs="12" className="mt-3">
                            <Spinner animation="grow" className="text-energo" style={{marginRight: 10}}/>
                            <Spinner animation="grow" className="text-energo" style={{marginRight: 10}}/>
                            <Spinner animation="grow" className="text-energo" style={{marginRight: 10}}/>
                        </Col>
                    </Row>
                </IconContentCard> :
            
            tokenValid  ? 
                <IconContentCard icon={<MdMarkEmailRead size={80} />}>
                    <Row>
                        <h5 className="text-energo">Willkommen im ENERGO Managementportal</h5>
                    </Row>
                    <Row className="mt-5 text-muted">
                        <p>Damit wir als Energiepool für Sie tätig werden können, sind nur noch einige Schritte zu erledigen.</p>
                        <ul style={{marginLeft: 20}}>
                            <li>Wählen Sie ein Passwort</li>
                            <li>Vervollständigen Sie Ihre Daten</li>
                            <li>Unterzeichen Sie unsere Vollmacht</li>
                            <li>Laden Sie eine Ausweiskopie hoch</li>
                        </ul>
                    </Row>
                    <Row className="mt-4">
                        <Col xs="12">
                            <p className="text-muted">
                                Geben Sie ein neues Passwort 
                                ein und klicken Sie auf <span className="text-energo">"Weiter"</span>
                            </p>
                            <PasswordComponent customer={customer} setCustomer={setCustomer} isMailVerify={isMailVerify} />
                        </Col>
                    </Row>
                </IconContentCard>
            :
                <IconContentCard icon={<FaUnlink size={80} />} variant="error">
                    <Row>
                        <h5 className="text-danger">Ihre E-Mail-Adresse konnte nicht verifiziert werden</h5>
                    </Row>
                    <Row className="mt-5">
                        <Col xs="12">
                            <p className="danger">{apiError}</p>
                        </Col>
                    </Row>
                    <Row className="mt-5 text-end">
                        <Col>
                            <Button onClick={() => navigate('/')} variant="danger">Zurück</Button>
                        </Col>
                    </Row>
                </IconContentCard>
            }
        </Container>
    )
}

export default MailVerifyPage;